import React from "react";
import CandidatesMain from "../../components/candidates/CandidatesMain";
import Footer from "src/components/common/Footer";
import { RODEO_PAGE_NAME } from "src/_config/site_statics";
import Sidebar from "src/components/common/Sidebar";
import Header from "src/components/common/Header";

const Candidates: React.FC = () => {
  return (
    <>
      <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.CANDIDATES} />
      <CandidatesMain />
      <Footer variant="dashboard" />
    </>
  );
};

export default Candidates;
